import { toConsumableArray as _toConsumableArray, objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { getTvObject, tv } from '@costar-ui/cosmos';
import flexOptions from '../../common/flex-options/flex-options.esm.js';
import { focusRing } from '../../theme/styles/common.esm.js';
import fontOptions from '../../common/font-options/font-options.esm.js';

var variant = getTvObject({
  primary: ['text-action-primary', 'decoration-primary', 'hover:decoration-primary', 'hover:text-action-primary', 'hover:underline'],
  secondary: ['decoration-base-inverse', 'hover:decoration-base-inverse', 'hover:text-action-base-inverse', 'hover:underline'],
  neutral: 'text-action-neutral',
  inherit: '',
  'icon-secondary': 'text-action-base-inverse',
  'menu-item': ['text-action-base-inverse', 'bg-transparent', 'border', 'border-transparent', 'hover:bg-accent-hover', 'hover:text-on-accent-hover', 'active:bg-action-base-active', 'active:text-on-action-base-active', 'focus:border-focus', 'disabled:bg-transparent', 'disabled:border-transparent', 'rounded-none', 'h-8', 'p-1.5', 'w-full']
});
var anchorTV = getTvObject({
  extend: focusRing,
  base: [].concat(_toConsumableArray(flexOptions.base), ['disabled:no-underline', 'disabled:cursor-default', 'forced-colors:disabled:text-action-disabled', 'transition', 'rounded', 'cursor-pointer', 'hover:text-action-neutral-hover', 'active:text-action-neutral-active', 'flex', 'gap-x-1']),
  variants: _objectSpread2(_objectSpread2({
    variant: variant,
    size: {
      sm: 'text-p-14',
      md: 'text-p-16',
      lg: 'text-p-18',
      xl: 'text-p-20',
      heading: 'text-p-18 leading-6'
    },
    weight: fontOptions.weight
  }, flexOptions.variants), {}, {
    fontFamily: fontOptions.fontFamily,
    inheritFontSize: {
      "true": 'text-size-inherit'
    },
    inheritColor: {
      "true": 'text-inherit'
    }
  })
});
var base = tv(anchorTV);
var anchorStyles = {
  base: base
};

export { anchorStyles, anchorTV };
//# sourceMappingURL=anchor.styles.esm.js.map
